<template>
  <div class="education-state" :class="`is-${state}`" role="status">
    <el-icon v-if="state === 'loading'" class="is-loading" :size="28"><Loading /></el-icon>
    <el-icon v-else-if="state === 'empty'" :size="28"><FolderOpened /></el-icon>
    <el-icon v-else-if="state === 'forbidden'" :size="28"><Lock /></el-icon>
    <el-icon v-else :size="28"><WarningFilled /></el-icon>
    <strong>{{ titleText }}</strong>
    <span v-if="description">{{ description }}</span>
    <el-button
      v-if="state === 'error' || state === 'forbidden'"
      type="primary"
      link
      @click="$emit('retry')"
    >
      {{ state === 'forbidden' ? '返回工作台' : '重新加载' }}
    </el-button>
    <el-button v-else-if="state === 'empty' && actionText" type="primary" @click="$emit('action')">
      {{ actionText }}
    </el-button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { FolderOpened, Loading, Lock, WarningFilled } from '@element-plus/icons-vue'

defineOptions({ name: 'EducationState' })

type EducationStateType = 'loading' | 'empty' | 'forbidden' | 'error'

const props = withDefaults(
  defineProps<{
    state: EducationStateType
    title?: string
    description?: string
    actionText?: string
  }>(),
  { title: '', description: '', actionText: '' }
)

defineEmits<{ retry: []; action: [] }>()

const titleText = computed(() => {
  if (props.title) return props.title
  return {
    loading: '正在加载',
    empty: '暂无数据',
    forbidden: '暂无访问权限',
    error: '数据加载失败'
  }[props.state]
})
</script>

<style scoped>
.education-state {
  display: flex;
  min-height: 180px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 28px;
  color: #697681;
  flex-direction: column;
  text-align: center;
}

.education-state strong {
  color: #17222d;
}
.education-state span {
  max-width: 420px;
  font-size: 13px;
  line-height: 1.6;
}
.is-forbidden {
  background: #fffaf0;
}
.is-error {
  background: #fff7f7;
}
</style>
